import * as React from 'react';

const HappyFace48 = ({ title, titleId, ...props }) => /* @__PURE__ */ React.createElement("svg", { fill: "none", viewBox: "0 0 48 48", width: 48, height: 48, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M16.195 27.712a1.25 1.25 0 0 0-2.158 1.263l.002.002.001.003.004.007.011.019q.014.021.035.056l.12.183c.103.151.252.358.45.602a11.5 11.5 0 0 0 1.794 1.764c1.625 1.284 4.118 2.553 7.572 2.553 3.38 0 5.87-1.273 7.505-2.548.815-.634 1.42-1.27 1.825-1.752a10 10 0 0 0 .588-.777l.036-.055.01-.017h.001l.003-.006v.002l-.02.03-.154.227.178-.265a1.25 1.25 0 0 0-2.124-1.319v.002l-.015.021-.075.11c-.072.1-.186.252-.342.439-.315.374-.796.88-1.447 1.388-1.297 1.01-3.261 2.02-5.969 2.02-2.794 0-4.756-1.014-6.023-2.015a9 9 0 0 1-1.401-1.376 7 7 0 0 1-.395-.54zm.865-6.492a2.313 2.313 0 1 0 0-4.626 2.313 2.313 0 0 0 0 4.626m13.88 0a2.313 2.313 0 1 0 0-4.626 2.313 2.313 0 0 0 0 4.626"
  }
), /* @__PURE__ */ React.createElement(
  "path",
  {
    fill: "currentColor",
    d: "M43.003 23.996C43.003 34.491 34.495 43 24 43S4.997 34.492 4.997 23.997 13.505 4.993 24 4.993s19.003 8.508 19.003 19.003M24 40.5c9.114 0 16.503-7.389 16.503-16.503S33.114 7.493 24 7.493 7.497 14.882 7.497 23.996 14.886 40.5 24 40.5"
  }
));
HappyFace48.Size = 48;
HappyFace48.Title = "HappyFace";

export { HappyFace48 as default };
